import {Action} from "redux";
import {ICustomerMypageActionCreator} from "../action/customer_mypage_action";
import {
    UpdatePasswordByCustomerRequest,
    UpdateCustomerByCustomerRequest,
    UpdateEmailByCustomerRequest, GenerateCustomerPDFByCustomerRequest, DestroyCustomerPDFByCustomerRequest,
} from "../request/mypage_request";

interface ICustomerMypageDispatcher {
    getMeCustomer(): void;

    updateCustomer(
        item: UpdateCustomerByCustomerRequest,
    ): void;

    updatePassword(
        item: UpdatePasswordByCustomerRequest,
    ): void;

    updateEmail(
        item: UpdateEmailByCustomerRequest,
    ): void;

    generateCustomerPDF(item: GenerateCustomerPDFByCustomerRequest): void;

    destroyCustomerPDF(item: DestroyCustomerPDFByCustomerRequest): void;
}

class Dispatcher implements ICustomerMypageDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerMypageActionCreator) {

    }

    public getMeCustomer = (): void => {
        this.dispatch(this.actionCreator.requestGetMeCustomerAction());
    };

    public updateCustomer = (
        item: UpdateCustomerByCustomerRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdateCustomerAction(item));
    };

    public updatePassword = (
        item: UpdatePasswordByCustomerRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdatePasswordAction(item));
    };

    public updateEmail = (
        item: UpdateEmailByCustomerRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdateEmailAction(item));
    };

    public generateCustomerPDF = (
        item: GenerateCustomerPDFByCustomerRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestGenerateCustomerPDFAction(item));
    };

    public destroyCustomerPDF = (
        item: DestroyCustomerPDFByCustomerRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestDestroyCustomerPDFAction(item));
    };
}

const createCustomerMypageDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerMypageActionCreator): ICustomerMypageDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerMypageDispatcher, createCustomerMypageDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_mypage_dispatcher.ts